import * as React from "react";
export var BF2HudBottomLeft = function () {
    return React.createElement(React.Fragment, null);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/hud/BF2HudBottomLeft.tsx
// module id = 2273
// module chunks = 3